import { NetlogHttpClient } from 'lib/http';
import { FileAttachment } from 'models';
import { AttachmentHandler, FileId } from './attachment-handler';

export type MooringOrderDocumentsHandlerArgs = {
  mooringOrderId: number;
};

export class MooringOrderDocumentsHandler implements AttachmentHandler {
  private _mooringOrderId: number;

  constructor(private client: NetlogHttpClient, args: MooringOrderDocumentsHandlerArgs) {
    this._mooringOrderId = args.mooringOrderId;
  }

  set mooringId(id: number) {
    this.mooringId = id;
  }

  get baseUrl() {
    return `api/mooring-sales-orders/${this._mooringOrderId}/attachments`;
  }

  upload(file: File) {
    const form = this.client.fileFormdata(file);
    return this.client.uploadFile(form, this.baseUrl);
  }

  delete(storageFileId: FileId) {
    return this.client.delete({
      url: `${this.baseUrl}/${storageFileId}`,
    });
  }

  download(storageFileId: FileId) {
    return this.client.downloadBlob(`api/system-storage/${storageFileId}`);
  }

  async metadata() {
    const response = await this.client.get<FileAttachment[]>(
      {
        url: `api/mooring-sales-orders/${this._mooringOrderId}/attachments`,
        model: FileAttachment,
      },
      { cache: false }
    );
    return response.data;
  }
}
